/*
 * jBone.widget.animation
 * Usage:
 * $('#element').animation(settings) //initialization
 * $('#element').animation('slideLineMenu') //apply animation
 *
 */

define(function(require) {
    'use strict';

    var $ = require('j');
    var slideLineMenu = require('widgets/animations/slideLineMenu');

    require('common/jbone.widget');

    var attachedWidgets = [];

    return $.widget('animation', {

        init: function() {
            this.removeAnimations(this);

            slideLineMenu.init(this);

            attachedWidgets.push(this);
        },

        removeAnimations: function() {
            attachedWidgets = attachedWidgets.reduce(function(array, widget) {
                if (!document.body.contains(widget.el)) {
                    widget.destroy();
                } else {
                    array.push(widget);
                }

                return array;
            }, []);
        }

    });
});
